<div>
  <div style="position: absolute; top: 10px; right: 25px"><a style="cursor: pointer" (click)="close()"><img
        src="./assets/images/close.svg" width="16" class="filter-invert" /></a></div>
  <div class="navbar-right-top">
    <div class="muted6">
      <last-updated [model]="model"></last-updated>
    </div>
  </div>
  <div [ngSwitch]="entityName" class="navbar-right-body">
    <ng-container *ngSwitchCase="'user'">
      <div class="navbar-right-title">
        <div class="large-text medium">
          {{model?.fullName}}
        </div>
      </div>
      <notes-detail [entityName]="entityName" [entityId]="entityId" [showAdd]="showNotesAdd"></notes-detail>
      <user-detail [model]="model"></user-detail>
    </ng-container>

    <ng-container *ngSwitchCase="'location'">
      <div class="navbar-right-title">
        <div class="large-text medium">
          {{model?.businessName}}
        </div>
      </div>

      <location-detail [model]="model" [showNotes]="true"></location-detail>
    </ng-container>

    <ng-container *ngSwitchCase="'invoice'">
      <invoice-detail [model]="model" [showHeader]="true" [showVehicles]="true"></invoice-detail>
    </ng-container>

    <ng-container *ngSwitchCase="'order'">
      <order-detail [model]="model" [showHeader]="true" [showVehicles]="true"></order-detail>
    </ng-container>

    <ng-container *ngSwitchCase="'quote'">
      <quote-detail [model]="model" [showHeader]="true" [showVehicles]="true" [showModal]="expanded"></quote-detail>
    </ng-container>
  </div>
</div>